import { MdClose, MdSearch } from "react-icons/md";

const Search = ({
  value,
  onChange,
  resultCount,
}: {
  value: string;
  onChange: (v: string) => void;
  /** Shown only while a query is active. */
  resultCount?: number;
}) => {
  const active = value.trim().length > 0;

  return (
    <div className="w-full flex flex-col items-center gap-2 px-2">
      <div className="w-full max-w-xl relative">
        <MdSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lightGray pointer-events-none" />
        <input
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search for a dish, brand or category…"
          aria-label="Search the menu"
          className="w-full pl-12 pr-11 py-3 rounded-full bg-white border border-black/5
            text-sm text-headingColor placeholder:text-lightGray shadow-sm
            focus:outline-none focus:border-cartNumBg/50 focus:ring-2 focus:ring-cartNumBg/15
            transition-all duration-150"
        />
        {active && (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="Clear search"
            className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full
              flex items-center justify-center text-lightGray
              hover:bg-cartNumBg/10 hover:text-cartNumBg transition-colors duration-150"
          >
            <MdClose className="text-lg" />
          </button>
        )}
      </div>

      {active && (
        <p className="text-xs sm:text-sm text-textColor">
          {resultCount === 0 ? (
            <>
              No matches for{" "}
              <span className="font-semibold text-headingColor">“{value.trim()}”</span>
            </>
          ) : (
            <>
              <span className="font-semibold text-headingColor">{resultCount}</span>{" "}
              {resultCount === 1 ? "result" : "results"} for{" "}
              <span className="font-semibold text-headingColor">“{value.trim()}”</span>
            </>
          )}
        </p>
      )}
    </div>
  );
};

export default Search;
